/**
 *
 * @module productType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ProductType
 * @type {Object}
 * @desc Defines the different product types that are supported.
 *
 * @property {String} D2C - Direct to consumer
 * @property {String} IAP - In app purchase
 *
 */

/**
 *
 * @enum
 * @type {ProductType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    D2C: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    IAP: null
});



// WEBPACK FOOTER //
// ./src/services/paywall/productType.js